import { ReportsList } from '@/views/dynamic-tables/dynamic-tables.types';

export interface State {
  dynamicTables: ReportsList[];
  dataLoaded: boolean;
}

const state: State = {
  dynamicTables: [],
  dataLoaded: false,
};

export default state;
